module.exports = __webpack_public_path__ + "img/bx09-2.9b646c12.jpg";